// eslint-disable-next-line deprecate/import
import Link from 'next/link';

import { ChainLinkVrf } from '@ui/uikit/components/icons/poly';

export const PredictionBanner = () => {
  return (
    <div className="inline-flex justify-center">
      <span className="bg-base-bg-secondary-blue text-caption-xs-a rounded-xl overflow-hidden px-2 py-1">
        <span className="text-caption-xs-a text-base-text-primary">
          <span className="whitespace-nowrap">The price is updated in real time</span>{' '}
          <span className="whitespace-nowrap">
            based on data from
            <ChainLinkVrf className="icon-xs mx-1" />
            <Link
              className="text-base-text-blue"
              href="https://docs.chain.link/data-feeds/price-feeds"
              target="_blank"
            >
              ChainLink
            </Link>
          </span>
        </span>
      </span>
    </div>
  );
};
